"use client";

import { BookOpen, Users, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Engagement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const steps = [{
    number: "01",
    icon: BookOpen,
    title: "Learn the Landscape",
    description: "Explore our educational resources to understand the unique ecosystems of Protection Island and Dungeness National Wildlife Refuges."
  }, {
    number: "02",
    icon: Users,
    title: "Join the Community",
    description: "Connect with fellow advocates and local volunteers dedicated to preserving our precious sea bird habitats and coastal wildlife."
  }, {
    number: "03",
    icon: ShieldCheck,
    title: "Take Action",
    description: "Participate in our conservation initiatives and help us inform the public on how to protect these vital wildlife sanctuaries."
  }];
  return <section data-section-id="412" id="how-to-engage" className="bg-background text-foreground relative overflow-hidden py-24 px-4 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" aria-hidden="true" style={{
      backgroundImage: "radial-gradient(circle at 20% 30%, var(--foreground) 1px, transparent 1px), radial-gradient(circle at 70% 60%, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "60px 60px, 80px 80px"
    }} />

      <div className="relative mx-auto max-w-7xl">
        {}
        <div className="mb-20 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-chart-2 mb-6">
            How to Engage
          </p>
          <h2 className="font-default font-semibold text-4xl sm:text-5xl lg:text-[52px] leading-[1.1] tracking-tight text-foreground max-w-3xl mx-auto">
            Protecting our <em className="italic text-primary">wildlife legacy</em>.
          </h2>
        </div>

        {}
        <div ref={ref} className="relative">
          {}
          <div className="hidden md:block absolute top-[70px] left-[16.66%] right-[16.66%] h-px pointer-events-none">
            <svg className="w-full h-px overflow-visible" preserveAspectRatio="none" viewBox="0 0 100 1">
              <line x1="0" y1="0.5" x2="100" y2="0.5" stroke="var(--chart-2)" strokeWidth="0.3" strokeDasharray="1.2 1.2" vectorEffect="non-scaling-stroke" style={{
              strokeDashoffset: isVisible ? 0 : 100,
              transition: "stroke-dashoffset 1500ms ease-out"
            }} pathLength={100} />
            </svg>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 relative">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="relative flex flex-col items-center text-center" style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(24px)",
              transition: `opacity 700ms ease-out ${i * 200}ms, transform 700ms ease-out ${i * 200}ms`
            }}>
                  {}
                  {i < steps.length - 1 && <div className="md:hidden absolute left-1/2 -translate-x-1/2 top-full h-16 w-px" style={{
                backgroundImage: "linear-gradient(to bottom, var(--chart-2) 50%, transparent 50%)",
                backgroundSize: "1px 8px",
                backgroundRepeat: "repeat-y",
                opacity: isVisible ? 1 : 0,
                transition: `opacity 700ms ease-out ${(i + 1) * 200}ms`
              }} aria-hidden="true" />}

                  {}
                  <div className="font-default font-semibold italic text-[84px] leading-none text-primary mb-2">
                    {step.number}
                  </div>

                  {}
                  <div className="relative mb-8">
                    <div className="w-[140px] h-[140px] rounded-lg bg-card border border-border flex items-center justify-center relative">
                      {}
                      <div className="absolute inset-3 rounded-lg border border-chart-2/30" />
                      <Icon className="w-14 h-14 text-foreground" strokeWidth={1} />
                      {}
                      <span className="absolute top-3 right-3 w-1.5 h-1.5 rounded-lg bg-chart-2" />
                      <span className="absolute bottom-3 left-3 w-1 h-1 rounded-lg bg-chart-2/60" />
                    </div>
                  </div>

                  {}
                  <h3 className="font-default font-semibold text-[26px] leading-tight text-foreground mb-4">
                    {step.title}
                  </h3>

                  {}
                  <p className="text-[15px] leading-relaxed text-muted-foreground max-w-[280px]">
                    {step.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}